"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var ClotheType_1 = __importDefault(require("./ClotheType"));
var ShirtCrewNeck_1 = __importDefault(require("./ShirtCrewNeck"));
var ShirtScoopNeck_1 = __importDefault(require("./ShirtScoopNeck"));
var ShirtVNeck_1 = __importDefault(require("./ShirtVNeck"));
var BlazerShirt_1 = __importDefault(require("./BlazerShirt"));
var GraphicShirt_1 = __importDefault(require("./GraphicShirt"));
var Hoodie_1 = __importDefault(require("./Hoodie"));
var CollarSweater_1 = __importDefault(require("./CollarSweater"));
var BlazerSweater_1 = __importDefault(require("./BlazerSweater"));
var Overall_1 = __importDefault(require("./Overall"));
var react_1 = require("react");
var AvatarContext_1 = __importDefault(require("../AvatarContext"));
function Clothes() {
    var _a;
    var type = (_a = react_1.useContext(AvatarContext_1.default).clotheType) !== null && _a !== void 0 ? _a : ClotheType_1.default.BlazerShirt;
    switch (type) {
        case ClotheType_1.default.BlazerShirt:
            return jsx_runtime_1.jsx(BlazerShirt_1.default, {}, void 0);
        case ClotheType_1.default.BlazerSweater:
            return jsx_runtime_1.jsx(BlazerSweater_1.default, {}, void 0);
        case ClotheType_1.default.CollarSweater:
            return jsx_runtime_1.jsx(CollarSweater_1.default, {}, void 0);
        case ClotheType_1.default.GraphicShirt:
            return jsx_runtime_1.jsx(GraphicShirt_1.default, {}, void 0);
        case ClotheType_1.default.Hoodie:
            return jsx_runtime_1.jsx(Hoodie_1.default, {}, void 0);
        case ClotheType_1.default.Overall:
            return jsx_runtime_1.jsx(Overall_1.default, {}, void 0);
        case ClotheType_1.default.ShirtCrewNeck:
            return jsx_runtime_1.jsx(ShirtCrewNeck_1.default, {}, void 0);
        case ClotheType_1.default.ShirtScoopNeck:
            return jsx_runtime_1.jsx(ShirtScoopNeck_1.default, {}, void 0);
        case ClotheType_1.default.ShirtVNeck:
            return jsx_runtime_1.jsx(ShirtVNeck_1.default, {}, void 0);
    }
}
exports.default = Clothes;
